import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { TextButton } from 'seagull';
import { PlusCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { PromptInputField } from '~/components/ai/PromptInputField/PromptInputField';
import { useLocaleKeys } from '~/i18n';
import { PdfAttachment } from '../shared/PdfAttachment/PdfAttachment';
export const GetChatInputTID = (parentTestId)=>getTestIds(parentTestId);
export const ChatInput = (param)=>{
    let { isThinking, isUploading, isAutoSaving, uploadingFileName, pendingAttachment, placeholderPool, onSubmit, onPdfUpload, onRemoveAttachment, testId } = param;
    var _ref;
    const { t } = useLocaleKeys();
    const [text, setText] = useState('');
    const fileInputRef = useRef(null);
    const { ChatInputTID } = useMemo(()=>GetChatInputTID(testId), [
        testId
    ]);
    const hasPendingAttachment = pendingAttachment != null;
    const displayedFileName = (_ref = pendingAttachment === null || pendingAttachment === void 0 ? void 0 : pendingAttachment.fileName) !== null && _ref !== void 0 ? _ref : uploadingFileName;
    const uploadDisabled = isThinking || isUploading || hasPendingAttachment;
    const submitDisabled = isThinking || isUploading || isAutoSaving || text.trim().length === 0 && !hasPendingAttachment;
    const handleSubmit = ()=>{
        onSubmit(text);
        setText('');
    };
    const handleUploadClick = ()=>{
        var _fileInputRef_current;
        if (uploadDisabled) return;
        (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    const handleFileChange = (event)=>{
        var _event_target_files;
        const file = (_event_target_files = event.target.files) === null || _event_target_files === void 0 ? void 0 : _event_target_files[0];
        if (file != null) onPdfUpload(file);
        event.target.value = '';
    };
    const attachmentChip = displayedFileName != null ? /*#__PURE__*/ _jsx(PdfAttachment, {
        fileName: displayedFileName,
        state: hasPendingAttachment ? 'loading-done' : 'loading',
        onRemove: onRemoveAttachment,
        removeAriaLabel: t.agenticDrafting.input.removeAttachmentLabel(),
        rootTestId: ChatInputTID.PendingAttachmentChip(),
        fileNameTestId: ChatInputTID.PendingAttachmentFileName(),
        spinnerTestId: ChatInputTID.PendingAttachmentSpinner(),
        removeButtonTestId: ChatInputTID.RemoveAttachmentButton()
    }) : null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PromptInputField, {
                testId: ChatInputTID.Container(),
                value: text,
                onChange: setText,
                onSubmit: handleSubmit,
                submitDisabled: submitDisabled,
                placeholder: t.agenticDrafting.input.placeholderTyped(),
                suggestions: placeholderPool,
                topContent: attachmentChip,
                leftActions: /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'upload_agent_chat_attachment'
                    },
                    underline: "none",
                    weight: "normal",
                    onClick: handleUploadClick,
                    disabled: uploadDisabled,
                    testId: ChatInputTID.UploadButton(),
                    prefixIcon: /*#__PURE__*/ _jsx(PlusCircle, {
                        size: 16
                    }),
                    children: t.agenticDrafting.input.uploadButton()
                })
            }),
            /*#__PURE__*/ _jsx("input", {
                ref: fileInputRef,
                type: "file",
                accept: "application/pdf",
                "data-testid": ChatInputTID.UploadFileInput(),
                onChange: handleFileChange,
                hidden: true
            })
        ]
    });
};
